<template>
  <div class="user-profile-card">
    <div class="profile-header">
      <img :src="logoSrc" alt="User Image" class="profile-image" />
    </div>
    <!-- <div class="profile-body">
      <div class="profile-details">
        <h2>{{ nickname }}</h2>
        <p v-if="permission == 0">{{ $t('developer') }}</p>
        <p v-else-if="permission == 1">{{ $t('manager') }}</p>
        <p v-else-if="permission == 2">{{ $t('customerService') }}</p>
        <p v-else>{{ $t('dealer') }}</p>
      </div>
      <div class="profile-actions">
        <button @click="logout">{{ $t('logout') }}</button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import logoIcon from '@/assets/logo_footer.png';

export default {
  name: 'UserProfileCard',
  data() {
    const token = Cookies.get('jwt');
    const decoded = jwtDecode(token);
    const id = ref(0);
    const nickname = ref('');
    const permission = ref(999);
    onMounted(async () => {
      id.value = decoded.data.id;
      nickname.value = decoded.data.nickname;
      permission.value = decoded.data.permission;
    });
    return {
      id,
      nickname,
      permission,
      logoSrc: logoIcon,
    };
  },
  methods: {
    logout() {
      this.$router.push('/logout');
    },
  },
};
</script>

<style scoped>
.user-profile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  width: 190px;
  margin: 5px;
}

.profile-image {
  width: 100%;
  height: 40px;
}

.profile-body {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  width: 100%;
  border: 1px solid darkgray;
  border-radius: 8px;
}

.profile-details {
  padding-left: 8px;
}

.profile-details h2,
.profile-details p {
  margin: 0;
  padding: 0;
  color: white;
  font-size: small;
}

.profile-actions button {
  padding: 10px 20px;
  background-color: #4285f4;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
}
</style>
